import DocsPage from './docs-page';

export default DocsPage;
